import { RegionShort } from "../../../Models";

export const getRegionsByCountryDict = (regions: RegionShort[]): { [name: string]: RegionShort[] } => {
  const dict: { [name: string]: RegionShort[] } = {};
  regions.forEach((item) => {
    const key = item.countryCode;
    const collection = dict[key];

    if (!collection) {
      dict[key] = [item];
    } else {
      collection.push(item);
    }
  });

  return dict;
};
